import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { redirectToMobileHomeIfNative } from "@/native/capacitorBootstrap";

// If we're running inside the Capacitor native shell, jump straight to
// /m/home so users land in the mobile menu grid built on Day 1.
redirectToMobileHomeIfNative();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
